
import { computed, defineComponent, onMounted, reactive, ref } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import usePlugin from "@/plugins";
import useState from "@/store";
import { GetAppInfoResponse, LoginRequest, LoginResponse } from "@/types";
import liff from "@line/liff";

export default defineComponent({
  name: "Login",
  setup() {
    const {
      router,
      success,
      axios,
      error,
      setAxiosBearer,
      queryProfile,
    } = usePlugin();
    const state = useState();

    const step = computed(() => {
      if (!login.lineUid) return 1;
      if (!login.token) return 2;
      return 3;
    });
    const profile = ref("");
    const login = reactive({
      lineUid: "",
      lineName: "",
      linePhoto: "",

      username: "",
      password: "",

      token: "",
    });
    const rules = {
      login: {
        username: {
          required: helpers.withMessage("กรุณาระบุ username", required),
        },
        password: {
          required: helpers.withMessage("กรุณาระบุ password", required),
        },
      },
    };

    const onLogin = async () => {
      v$.value.$touch();
      if (!(await v$.value.$validate())) return;
      await onLineLogin();
      router.push({ name: "Home" });
    };

    const v$ = useVuelidate(rules, { login });

    const onLink = () => {
      liff.login();
    };

    const loadLiffId = async () => {
      state.value.isLoading = true;
      try {
        const result = await axios.get<GetAppInfoResponse>(
          "api/v1/lineLogin/appInfo"
        );
        state.value.liffId = result.data.liffId;
      } catch (e) {
        error(e);
      } finally {
        state.value.isLoading = false;
      }
    };

    const onLineLogout = () => {
      liff.logout();
      window.location.reload();
    };

    const onLineLogin = async () => {
      state.value.isLoading = true;
      try {
        var result = await axios.post<LoginResponse>("api/v1/lineLogin/login", {
          username: login.username,
          password: login.password,
          lineUid: login.lineUid,
        } as LoginRequest);

        if (result.data.isSuccess !== true) {
          error(result.data.errorMessage);
          return;
        } else {
          state.value.token = result.data.token ?? "";
          state.value.userId = result.data.userId;
          setAxiosBearer();
          await queryProfile();

          router.replace({ name: "Home" });
        }
      } catch (e) {
        error(e);
      } finally {
        state.value.isLoading = false;
      }
    };

    onMounted(async () => {
      await loadLiffId();
      try {
        await liff.init({ liffId: state.value.liffId });
      } catch (e) {
        error(e);
      }

      if (liff.isLoggedIn()) {
        const result = await liff.getProfile();
        login.lineUid = result.userId;
        login.lineName = result.displayName;
        login.linePhoto = result.pictureUrl ?? "";

        await onLineLogin();
      }
    });

    return {
      login,
      v$,
      onLogin,
      onLink,
      state,
      profile,
      step,
      onLineLogout,
      onLineLogin,
    };
  },
});
